import Link, { LinkProps } from "@mui/material/Link";
import { IconArrowRight } from "src/components/icons-mui/arrow-right";

export const ArrowLink = ({ children, ...linksProps }: LinkProps) => {
    const hoverColor = linksProps.color === "green" ? "green.600" : "gray.800";

    return (
        <Link
            underline="hover"
            sx={{
                "&:hover": {
                    color: hoverColor,
                    "&.MuiLink-underlineAlways": {
                        textDecorationColor: hoverColor,
                    },
                },
            }}
            {...linksProps}
        >
            <>
                {children}
                <IconArrowRight sx={{ marginLeft: 0.5 }} />
            </>
        </Link>
    );
};
